import { GetterTree, MutationTree, Module } from 'vuex';
import { LoadingState, RootState } from '@/types';

type LoadingGetter = GetterTree<LoadingState, RootState>;

export const initialState = (): LoadingState => {
  return {
    initialState,
    loading: false,
    bypass: false,
    overlay: false,
    requestCount: 0,
    showInterface: false,
  };
};

export const getters: LoadingGetter = {
  loading: (state) => state,
};

export const mutations: MutationTree<LoadingState> = {
  addNetwork(state, network) {
    state.loading = network.loading;
  },
  setBypass(state, bypass) {
    state.bypass = bypass;
  },
  setOverlay(state, show) {
    state.overlay = show;
  },
  incrementRequestCount(state) {
    state.requestCount++;
  },
  decrementRequestCount(state) {
    let count = state.requestCount;
    count--;
    if (count < 0) {
      count = 0;
    }
    state.requestCount = count;
  },
  setShowInterface(state, show) {
    state.showInterface = show;
  },
};

export const loading: Module<LoadingState, RootState> = {
  state: initialState(),
  getters,
  mutations,
};
